import { parseRiderName, riderAvatarStyle, flagEmoji } from '../../../lib/riderDisplay';
import { cn } from '../../../lib/cn';

/** Rider monogram with a tiny nationality badge — matches the mockup avatar stack. */
export function RiderAvatar({
  name,
  nationality,
  size = 'md',
  className
}: {
  name: string;
  nationality?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const { initials } = parseRiderName(name);
  const avatar = riderAvatarStyle(name);
  const flag = flagEmoji(nationality);
  const dim =
    size === 'xs'
      ? 'h-[15px] w-[15px] text-[7px]'
      : size === 'sm'
        ? 'h-[30px] w-[30px] text-[10px]'
        : size === 'lg'
          ? 'h-9 w-9 text-xs'
          : 'h-[34px] w-[34px] text-[11px]';
  const badge =
    size === 'sm'
      ? 'right-[-2px] bottom-[-2px] h-[10px] min-w-[14px] text-[7px]'
      : size === 'lg'
        ? 'right-[-3px] bottom-[-3px] h-[11px] min-w-[16px] text-[8px]'
        : 'right-[-2px] bottom-[-2px] h-[10px] min-w-[15px] text-[8px]';

  return (
    <div className={cn('relative shrink-0', className)}>
      <div
        className={cn('grid place-items-center rounded-full font-extrabold tracking-[-0.02em]', dim)}
        style={{ background: avatar.background, color: avatar.color }}
      >
        {initials}
      </div>
      {flag && size !== 'xs' ? (
        <span
          className={cn(
            'absolute grid place-items-center rounded-[2px] border-[1.5px] border-white bg-white shadow-[0_1px_2px_rgba(0,0,0,0.25)] leading-none',
            badge
          )}
          aria-hidden
        >
          {flag}
        </span>
      ) : null}
    </div>
  );
}
